export default __webpack_public_path__ + "static/media/1290.65bde41b.png";